import React, { useEffect, useState } from 'react'
import './styles/additional-settings.scss'
import { CaretLeft } from '@phosphor-icons/react'
import { Button } from 'antd'
import { creationEventStore } from 'state/event/eventCreationStore'
import CoverAndDescription from './essentialComp/CoverAndDescription'
import AdditionalSettings from './essentialComp/AdditionalSettings'
import { useEventAdditionalSetting } from 'api/EventCreation/creationStep5'
import ButtonSpinner from 'components/global/ButtonSpinner'
import { EventStep5Payload } from 'types/event/eventStep5'
import Confirmationmodal from './Modals/Confirmationmodal'

interface AdditionalEventSettingsProps {
  handleNext: (data: any) => void
  handleBack: () => void
}

const AdditionalEventSettings: React.FC<AdditionalEventSettingsProps> = ({
  handleNext,
  handleBack,
}) => {
  const {
    eventData,
    setEventData,
    agreements,
    setAgreements,
    itemsToBring,
    setItemsToBring,
    selectedFaqIds,
    setSelectedFaqIds,
    selectedRequiredDocumentIds,
    setSelectedRequiredDocumentIds,
  } = creationEventStore(store => ({
    eventData: store.eventData,
    setEventData: store.setEventData,
    agreements: store.agreements,
    setAgreements: store.setAgreements,
    itemsToBring: store.itemsToBring,
    setItemsToBring: store.setItemsToBring,
    selectedFaqIds: store.selectedFaqIds,
    setSelectedFaqIds: store.setSelectedFaqIds,
    selectedRequiredDocumentIds: store.selectedRequiredDocumentIds,
    setSelectedRequiredDocumentIds: store.setSelectedRequiredDocumentIds,
  }))
  const [confirmModal, setConfirmModal] = useState<boolean>(false)

  const { mutate: step5Mutation, isLoading: step5Loading } =
    useEventAdditionalSetting()

  const handleStep5CompleteClick = () => {
    const payload: EventStep5Payload = {
      requiredDocumentIds: selectedRequiredDocumentIds,
      itemsToBringIds: itemsToBring,
      faqIds: selectedFaqIds,
      agreementIds: agreements,
    }

    step5Mutation(
      { payload, eventId: eventData._id },
      {
        onSuccess: data => {
          setEventData({ ...eventData, ...data })
          handleNext(data)
        },
      },
    )
  }

  useEffect(() => {
    setItemsToBring(eventData.itemsToBringIds || [])
    setSelectedFaqIds(eventData.faqIds || [])
    setSelectedRequiredDocumentIds(eventData.requiredDocumentIds || [])
    setAgreements(eventData.agreementIds || [])
  }, [])

  return (
    <>
      <div className="additional-setting-container">
        <div>
          <h3 className="text-24 w-600"> Step 5. Communication</h3>
        </div>
        <div className="mt-30px overflow-auto-y scroller overflow-hidden-x content-container">
          <AdditionalSettings />
        </div>

        <div className="mt-15px event-button-cont">
          <h5
            className="flex gap-10px align-center pointer"
            onClick={() => handleBack()}
          >
            <CaretLeft size={20} color="#000" />
            <span className="text-15 w-500">Back</span>
          </h5>
          <Button className="stepper-button" onClick={handleStep5CompleteClick}>
            {step5Loading ? <ButtonSpinner size={20} color="#000" /> : 'Next'}
          </Button>
        </div>
      </div>

      {confirmModal && (
        <Confirmationmodal
          openModal={confirmModal}
          closeModal={setConfirmModal}
        />
      )}
    </>
  )
}

export default AdditionalEventSettings
